module.exports = __webpack_public_path__ + "static/img/interactionLive08.4b5b85e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/interactionLive08.png
// module id = hQRj
// module chunks = 0